import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ArrowDown2 } from 'iconsax-react';

import { cn } from '@shared/lib';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    dir='rtl'
    ref={ref}
    className={cn(
      'md:border md:border-border md:border-b-0 last:border-b text-text md:first:rounded-t last:rounded-b border-transparent',
      className
    )}
    {...props}
  />
));
AccordionItem.displayName = 'AccordionItem';

interface AccordionTriggerProps
  extends React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> {
  arrowIconShow?: boolean;
}

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  AccordionTriggerProps
>(({ className, arrowIconShow, children, color = 'text-text', ...props }, ref) => (
  <AccordionPrimitive.Header className='flex'>
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        'border-b-0 flex flex-1 items-center justify-between py-4 pr-5 pl-2 h5-bold leading-[24px] transition-all [&[data-state=open]>svg]:rotate-180 focus-visible:outline-none disabled:bg-disableBg disabled:text-disableText md:hover:bg-hover',
        color,
        className
      )}
      {...props}
    >
      {children}
      {!arrowIconShow && (
        <ArrowDown2
          size={32}
          className={cn('p-2 shrink-0 transition-transform duration-200 rounded-md', color)}
        />
      )}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className='overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down'
    {...props}
  >
    <div className={cn('p-5', className)}>{children}</div>
  </AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
